import { useEffect, useMemo, useState } from 'react';
import { useWallets } from '@privy-io/react-auth';

function useWalletReady() {
  const { ready: privyWalletReady, wallets } = useWallets();
  const [walletReady, setWalletReady] = useState(false);

  const embeddedWallet = useMemo(() => wallets.find((w) => w.connectorType === 'embedded'), [wallets]);

  useEffect(() => {
    console.log(`------PRIVY WALLET READY: ${privyWalletReady} Embedded wallet:`, embeddedWallet);
    console.log('------WALLETS:', wallets);
    setWalletReady(!!embeddedWallet && privyWalletReady);
  }, [embeddedWallet, privyWalletReady]);

  return walletReady;
}

export default useWalletReady;
